import ArticleCommentModel from './ArticleCommentModel';
import moment from 'moment';

export default class ArticleModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.topic = data.topic || '';
    this.description = data.description || '';
    this.num_comments = data.num_comments || 0;
    
    this.created = moment(data.created).toDate();
    this.ordered_comments = (data.ordered_comments || []).map(c => new ArticleCommentModel(c));
  }
}
